import { authSession, useLogin } from "@/authentication/authenticationService"
import { getCookie, removeCookie } from "@/lib/shared/useCookies.ts"
import ErrorReporter from "@/services/ErrorReporter"
import type { NavigationGuard } from "vue-router"

const AUTO_LOGIN_QUERY_PARAM = "auto-login-from-cookie"
const AUTO_LOGIN_COOKIE_NAME = "myaccount-auto_login_credential"

export const autoLoginGuard: NavigationGuard = async (to) => {
  if (!(AUTO_LOGIN_QUERY_PARAM in to.query)) return

  try {
    const credential = getCookie(AUTO_LOGIN_COOKIE_NAME)

    if (credential?.otp && credential?.email) {
      removeCookie(AUTO_LOGIN_COOKIE_NAME)

      await useLogin().mutateAsync({
        data: {
          email: credential.email,
          password: credential.otp,
          extendedSession: false,
        },
      })
    }
  } catch (error) {
    authSession.clearSessionData()
    ErrorReporter.report(error)
    console.error(error)
  }

  const { ...query } = to.query
  delete query[AUTO_LOGIN_QUERY_PARAM]
  return { path: to.path, query, replace: true }
}
